import script from "./MainHeaderMenuNav.vue?vue&type=script&setup=true&lang=js"
export * from "./MainHeaderMenuNav.vue?vue&type=script&setup=true&lang=js"

import "./MainHeaderMenuNav.vue?vue&type=style&index=0&id=9cc565c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cc565c6"]])

export default __exports__